export default {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    GOOGLE_APP_ID: process.env.REACT_APP_GOOGLE_APP_ID,
    FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
    UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL,
    ARTICLES_PER_PAGE: process.env.REACT_APP_ARTICLES_PER_PAGE,
  };